export const environment = {
  production: true,
  BACKEND_SERVER_URL: '/api/v1',
  bugsnagApiKey: 'f91b478e957645ed810e9f04ebb4ceb5',
  bugsnagStage: 'production'

};
